import { isRef, onMounted, ref, unref, watch } from 'vue';
import get from 'lodash-es/get';
import { MaybeRef } from '@/types';

function getAssociation(name: string): string {
  if (name.indexOf('.') > -1) {
    return name.split('.')[0];
  } else {
    return '';
  }
}

function getAssociationField(name: string): string {
  if (name.indexOf('.') > -1) {
    if (!isNaN(parseInt(name.split('.')[1], 10))) {
      return name.split('.')[2];
    } else {
      return name.split('.')[1];
    }
  } else {
    return '';
  }
}

function getAssociationIndex(name: string): string {
  if (name.indexOf('.') > -1 && !isNaN(parseInt(name.split('.')[1], 10))) {
    return name.split('.')[1];
  } else {
    return '';
  }
}

/**
 * Un champ peut porter son chemin complet dans les valeurs du formulaire
 * (`weekdays[0].time_ranges[1].start`) : le découpage par association ne sait pas le
 * suivre, la lecture par chemin prend alors le relais.
 */
function getApiErrorMessage(errors: object, name: string) {
  return getErrorByAssociation(errors, name) || getErrorByPath(errors, name);
}

function getErrorByPath(errors: object, name: string) {
  return firstMessage(get(errors, name));
}

function firstMessage(fieldErrors: unknown) {
  if (!fieldErrors || typeof fieldErrors !== 'object') {
    return null;
  }

  return fieldErrors[Object.keys(fieldErrors)[0]];
}

function getErrorByAssociation(errors: object, name: string) {
  // Permet d'aller dans les associations
  const association = getAssociation(name);
  const associationField = getAssociationField(name);
  const associationIndex = getAssociationIndex(name);
  if (typeof errors !== 'object') {
    return null;
  }

  if (Object.keys(errors).length > 0) {
    if (errors[association]?.[associationIndex]) {
      return errors[association]?.[associationIndex]?.[associationField]?.[
        Object.keys(errors[association][associationIndex][associationField])[0]
      ];
    } else if (associationIndex === '' && errors[association]) {
      return errors[association]?.[Object.keys(errors[association])[0]];
    } else if (association === '') {
      return errors[name]?.[Object.keys(errors[name])[0]];
    } else {
      return '';
    }
  }
}

export function useFormApiError(
  name: MaybeRef<string>,
  errors: MaybeRef<object>,
) {
  const apiErrorMessage = ref<string>(null);
  onMounted(() => {
    apiErrorMessage.value = getApiErrorMessage(unref(errors), unref(name));
  });
  if (isRef(errors)) {
    watch(errors, () => {
      apiErrorMessage.value = getApiErrorMessage(unref(errors), unref(name));
    });
  }

  return {
    apiErrorMessage,
  };
}
